import styled from "styled-components";
import { MOBILE_WIDTH } from "../../constants";

export const ContactPageContainer = styled.div`
  width: 100%;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContactFormContainer = styled.div`
  width: 50%;
  background-color: #fff;
  padding: 32px;
  @media ${MOBILE_WIDTH} {
    width: 100%;
    padding: 16px;
  }
`;

export const ContactFormTitle = styled.h1`
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  margin: 0;
`;

export const ContactFormLabel = styled.label`
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
`;

export const ContactFormText = styled.p`
  font-family: Oswald;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  margin: 0;
`;

export const ContactFormInput = styled.input`
  font-family: Oswald;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  margin: 0;
  width: calc(100% - 6px);
  border-radius: 0;
  border-color: #000;
  border-width: 1px;
`;

export const ContactFormTextArea = styled.textarea`
  font-family: Oswald;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  margin-top: 8px;
  width: calc(100% - 6px);
  border-radius: 0;
  border-color: #000;
  border-width: 1px;
  resize: vertical;
  height: 48px;
  max-height: 120px;
`;

export const ContactFormMapContainer = styled.div`
  height: 330px;
  margin-top: 32px;
`;
